import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'activity-female-walking': {
			// ?safe&mock-data&utm_source=FB&country=US&area=activity-female-walking&exp=web_see_visible_results_in_4_weeks~1
			features: {
				dateEndIgnoreMinimumDuration: true,
			},
			funnel: {
				id: 'ob-see-visible-results-in-4-weeks',
				locale: ['en'],
			},
		},
	},
]

export default config
